export default __webpack_public_path__ + "static/media/jewelry.71a10c15.png";